import { render } from "./InviteFriendButton.vue?vue&type=template&id=13417f12&scoped=true"
import script from "./InviteFriendButton.vue?vue&type=script&lang=js"
export * from "./InviteFriendButton.vue?vue&type=script&lang=js"

import "./InviteFriendButton.vue?vue&type=style&index=0&id=13417f12&lang=stylus&scoped=true"
script.render = render
script.__scopeId = "data-v-13417f12"

export default script